import { v4 as uuid } from "uuid";

export const RENT = [
  {
    id: uuid(),
    title: "ПАЛАТКА MESUCA OUTDOOR",
    img: "tent2Mesuca.jpg",
    desc: "2-местная легкая однослойная палатка 200*100*100",
    category: "rent",
    day: "будни/выходные",
    price: 12,
    shortly: "Простая и лёгкая палатка типа Camping Tent",
    column: [
      "Тип конструкции: Быстрое автоматическое открытие",
      "Материал шеста: Алюминиевый корпус",
      "Индекс наружной водоустойчивости палатки 1000-1500 мм",
      "Водоустойчивый индекс нижней части 1000-1500 мм",
      "Сезон: Палатка на три сезона",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА ARTEN LIGHT 2",
    img: "arten_light2.png",
    desc: "2-х местная cамораскрывающаяся однослойная палатка 230*110*90",
    category: "rent",
    day: "пн-чт аренда",
    price: 13,
    shortly:
      "Хорошая вентиляция и мгновенное раскладывание, минимальный вес и комфорт, защита от лёгкой непогоды",
    column: [
      "Производитель: ARTEN",
      "Материал каркаса: Фибергласс 7,9 мм",
      "Материал тента: 100% полиэстер 75D/190T PU W/R",
      "Водостойкость тента (мм в. ст): 2000",
      "Материал дна: Терпаулинг (армированный полиэтилен)",
      "Водостойкость дна (мм в. ст.): 10000",
      "Вес (г): 1800",
      "Количество слоев: 1",
      "Количество мест: 2",
      "Количество входов: 1",
      "Высота (см): 90",
      "Упаковка: Тканевый мешок",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА ARTEN LIGHT 2",
    img: "arten_light2.png",
    desc: "2-х местная cамораскрывающаяся однослойная палатка 230*110*90",
    category: "rent",
    day: "пт-вс аренда",
    price: 16,
    shortly:
      "Хорошая вентиляция и мгновенное раскладывание, минимальный вес и комфорт, защита от лёгкой непогоды",
    column: [
      "Производитель: ARTEN",
      "Материал каркаса: Фибергласс 7,9 мм",
      "Материал тента: 100% полиэстер 75D/190T PU W/R",
      "Водостойкость тента (мм в. ст): 2000",
      "Материал дна: Терпаулинг (армированный полиэтилен)",
      "Водостойкость дна (мм в. ст.): 10000",
      "Вес (г): 1800",
      "Количество слоев: 1",
      "Количество мест: 2",
      "Количество входов: 1",
      "Высота (см): 90",
      "Упаковка: Тканевый мешок",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА ARTEN SPACE",
    img: "ARTEN_SPACE.webp",
    desc: "2-х местная легкая однослойная палатка 210*150*120",
    category: "rent",
    day: "пн-чт аренда",
    price: 12,
    shortly:
      "Легкая однослойная палатка. Вход спального отделения продублирован москитной сеткой. Большой вентиляционный клапан. Все швы проклеены. Идеальна для простых походов в весеннее, летнее и осеннее время.",
    column: [
      "Производитель: ARTEN",
      "Материал каркаса: Фибергласс 7,9 мм",
      "Материал тента: 100% полиэстер 75D/190T PU W/R",
      "Водостойкость тента (мм в. ст): 2000",
      "Материал дна: Армированный полиэтилен (терпаулинг)",
      "Водостойкость дна (мм в. ст.): 10000",
      "Вес (г): 1800",
      "Количество слоев: 1",
      "Количество мест: 2",
      "Количество входов: 1",
      "Высота (см): 120",
      "Наружний габарит (см): 210*150",
      "Упаковка: Тканевый мешок",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА ARTEN SPACE",
    img: "ARTEN_SPACE.webp",
    desc: "2-х местная легкая однослойная палатка 210*150*120",
    category: "rent",
    day: "пт-вс аренда",
    price: 15,
    shortly:
      "Легкая однослойная палатка. Вход спального отделения продублирован москитной сеткой. Большой вентиляционный клапан. Все швы проклеены. Идеальна для простых походов в весеннее, летнее и осеннее время.",
    column: [
      "Производитель:ARTEN",
      "Материал каркаса: Фибергласс 7,9 мм",
      "Материал тента: 100% полиэстер 75D/190T PU W/R",
      "Водостойкость тента (мм в. ст): 2000",
      "Материал дна: Армированный полиэтилен (терпаулинг)",
      "Водостойкость дна (мм в. ст.): 10000",
      "Вес (г): 1800",
      "Количество слоев: 1",
      "Количество мест: 2",
      "Количество входов: 1",
      "Высота (см): 120",
      "Наружний габарит (см): 210*150",
      "Упаковка: Тканевый мешок",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА QUECHUA MH-100",
    img: "DECATHLON2ух.jpg",
    desc: "2-х местная двухслойная палатка 130*210*107",
    category: "rent",
    day: "пн-чт аренда",
    price: 16,
    shortly:
      "Простая и легкая в установке, эта эко-палатка предназначена для ваших лагерей на 2 человек. Экологичная и недорогая палатка. Благодаря отдельно стоящей куполообразной конструкции вы можете перемещать палатку, чтобы выбрать наиболее подходящее для вас место для кемпинга.",
    column: [
      "Комната: 130*210 см",
      "Рост: 107см",
      "Размер корпуса: 58*16*16 см / 12 л",
      "Вес: 2.6 кг ",
      "Ткань с защитой SPF 30: Пропускает дневной свет, фильтрует УФ-лучи",
      "Водостойкость навес (мм в. ст.): 2000",
      "Водостойкость дна (мм в. ст.): 2400",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА QUECHUA MH-100",
    img: "DECATHLON2ух.jpg",
    desc: "2-х местная двухслойная палатка 130*210*107",
    category: "rent",
    day: "пт-вс аренда",
    price: 20,
    shortly:
      "Простая и легкая в установке, эта эко-палатка предназначена для ваших лагерей на 2 человек. Экологичная и недорогая палатка. Благодаря отдельно стоящей куполообразной конструкции вы можете перемещать палатку, чтобы выбрать наиболее подходящее для вас место для кемпинга.",
    column: [
      "Комната: 130*210 см",
      "Рост: 107см",
      "Размер корпуса: 58*16*16 см / 12 л",
      "Вес: 2.6 кг ",
      "Ткань с защитой SPF 30: пропускает дневной свет, фильтрует УФ-лучи",
      "Водостойкость навес (мм в. ст.): 2000",
      "Водостойкость дна (мм в. ст.): 2400",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА QUECHUA MH-100",
    img: "DECATHLON2ух.jpg",
    desc: "3-х местная двухслойная палатка 195*210*120",
    category: "rent",
    day: "пн-чт аренда",
    price: 18,
    shortly:
      "Простая и легкая в установке, эта эко-палатка предназначена для ваших лагерей на 3 человека. Благодаря отдельно стоящей куполообразной конструкции вы можете перемещать палатку, чтобы выбрать наиболее подходящее для вас место для кемпинга.",
    column: [
      "Задняя вентиляция",
      "Выдерживает ветер силой 5 баллов (40 км/ч)",
      "Комната 195*210 см",
      "Высота: 120 см",
      "Размер корпуса: 59*17*17 см / 13 л",
      "Вес: 3.4 кг",
      "Ткань с защитой SPF 30: Прропускает дневной свет, фильтрует УФ-лучи",
      "Водостойкость навес (мм в. ст.): 2000",
      "Водостойкость дна (мм в. ст.): 2400",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА QUECHUA MH-100",
    img: "DECATHLON2ух.jpg",
    desc: "3-х местная двухслойная палатка 130*210*107",
    category: "rent",
    day: "пт-вс аренда",
    price: 22,
    shortly:
      "Простая и легкая в установке, эта эко-палатка предназначена для ваших лагерей на 3 человека. Благодаря отдельно стоящей куполообразной конструкции вы можете перемещать палатку, чтобы выбрать наиболее подходящее для вас место для кемпинга.",
    column: [
      "Задняя вентиляция",
      "Выдерживает ветер силой 5 баллов (40 км/ч)",
      "Комната 195*210 см",
      "Высота: 120 см",
      "Размер корпуса: 59*17*17 см / 13 л",
      "Вес: 3,4 кг",
      "Ткань с защитой SPF 30: Пропускает дневной свет, фильтрует УФ-лучи",
      "Водостойкость навес (мм в. ст.): 2000",
      "Водостойкость дна (мм в. ст.): 2400",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА BESTWAY PAVILLO COOLDOME",
    img: "bestwat_pavillo.jpg",
    desc: "3-х местная однослойная палатка 210*210*130",
    category: "rent",
    day: "пн-чт аренда",
    price: 13,
    shortly:
      "Палатка Pavillo Activemount 3 идеально подходит для активного туриста, который хочет начать свой день на свежем воздухе. Эта прочная двухслойная палатка изготовлена из огнезащитного материала с водонепроницаемыми швами. Туристическая палатка подойдет для использования в любых погодных условиях. Предусмотрен специальный козырек, который служит как дополнительное пространство для хранения вещей. Материал палатки - высококачественный водонепроницаемый полиэстер. Пол палатки выполнен из структурированного полиэтилена. Имеется внутренний карман для личных вещей. Швы палатки герметичны и проклеены. Есть противомоскитная сетка.",
    column: [
      "Водостойкость тента: 300.00 мм вод. ст",
      "Водостойкость дна: 300.00 мм вод. ст",
      "Вес: 2.20 кг",
      "Размер корпуса: 210*210*130",
      "Вентиляционные окна",
      "Материал тента: Полиэстер",
      "Материал пола: Армированный полиэтелен",
      "Материал дуг: Cтеклопластик",
      "Материал колышков: Cталь",
      "Количество мест: 3 чел",
      "Габариты транспортной упаковки: 14*60*14см",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА BESTWAY PAVILLO COOLDOME",
    img: "bestwat_pavillo.jpg",
    desc: "3-х местная однослойная палатка 210*210*130",
    category: "rent",
    day: "пт-вс аренда",
    price: 16,
    shortly:
      "Палатка Pavillo Activemount 3 идеально подходит для активного туриста, который хочет начать свой день на свежем воздухе. Эта прочная двухслойная палатка изготовлена из огнезащитного материала с водонепроницаемыми швами. Туристическая палатка подойдет для использования в любых погодных условиях. Предусмотрен специальный козырек, который служит как дополнительное пространство для хранения вещей. Материал палатки - высококачественный водонепроницаемый полиэстер. Пол палатки выполнен из структурированного полиэтилена. Имеется внутренний карман для личных вещей. Швы палатки герметичны и проклеены. Есть противомоскитная сетка.",
    column: [
      "Водостойкость тента: 300.00 мм вод. ст",
      "Водостойкость дна: 300.00 мм вод. ст",
      "Вес: 2.20 кг",
      "Размер корпуса: 210*210*130",
      "Вентиляционные окна",
      "Материал тента: Полиэстер",
      "Материал пола: Армированный полиэтелен",
      "Материал дуг: Cтеклопластик",
      "Материал колышков: Cталь",
      "Количество мест: 3 чел",
      "Габариты транспортной упаковки:14х60х14см",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА BESTWAY COOLMOUNT4",
    img: "COOLMOUNT4.jpg",
    desc: "4-х местная самораскрывающаяся однослойная 240*210*100 см",
    category: "rent",
    day: "пн-чт аренда",
    price: 13,
    shortly:
      "Вам не надо ее устанавливать, просто положите ее на место установки и она разложится сама. В модели предусмотрена увеличенная вентиляция за счет больших окон по сторонам.Для переноски и хранения есть сумка чехол. Складывается в дискообразную сумку.",
    column: [
      "Бренд: Pavillo",
      "Размер палатки: 240*210*100 см.",
      "Вес: 2.3 кг.",
      "Водоотталкивающие свойства тента: 2000 мм.",
      "Водоотталкивающие свойства пола: 20000 мм.",
      "Кол. спальных мест: 4",
      "Габариты транспортной упаковки: 90*90*3 см",
    ],
  },
  {
    id: uuid(),
    title: "ПАЛАТКА BESTWAY COOLMOUNT4",
    img: "COOLMOUNT4.jpg",
    desc: "4-х местная самораскрывающаяся однослойная 240*210*100 см",
    category: "rent",
    day: "пт-вс аренда",
    price: 16,
    shortly:
      "Вам не надо ее устанавливать, просто положите ее на место установки и она разложится сама. В модели предусмотрена увеличенная вентиляция за счет больших окон по сторонам.Для переноски и хранения есть сумка чехол. Складывается в дискообразную сумку.",
    column: [
      "Бренд: Pavillo",
      "Размер палатки: 240*210*100 см.",
      "Вес: 2.3 кг.",
      "Водоотталкивающие свойства тента: 2000 мм.",
      "Водоотталкивающие свойства пола: 20000 мм.",
      "Кол. спальных мест: 4",
      "Габариты транспортной упаковки: 90*90*3 см",
    ],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК BTRACE ZERO L SIZE ПРАВЫЙ",
    img: "BTRACE_ZERO_L.png",
    desc: "Супер лёгкий 220*90(55) от +15 до 0 ",
    category: "rent",
    day: "пн-чт аренда",
    price: 12,
    shortly:
      "Новинка сезона 2021 - супер лёгкий спальный мешок-кокон BTrace Zero. Он идеально подойдёт для небольших путешествий в теплую погоду. Занимая совсем мало места, этот спальный мешок позволит с комфортом переночевать в походных условиях. Как и другие спальные мешки-коконы этой серии, BTrace Zero имеет возможность состёгиваться. Также можно выбрать один из 2х размеров, чтоб сэкономить ещё места и веса, если рост позволяет пользоваться спальным мешком меньшего размера.",
    column: [
      "Производитель: BTRACE",
      "Температура экстрима: 0",
      "Температура комфорта: +5",
      "Вес (г): 800",
      "Материал внешний: Полиэстер 20D 380Т Nylon RipStop WR",
      "Внутренний материал: 100% полиэстер 210T Soft Nylon",
      "Утеплитель: Izoshell Pro 2*80 г/м2",
      "Размер в упаковке (см): 52*25*25",
      "Размер (см): 220*90(55)",
      "Упаковка: Тканевый мешок",
    ],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК BTRACE ZERO L SIZE ПРАВЫЙ",
    img: "BTRACE_ZERO_L.png",
    desc: "Супер лёгкий 220*90(55) от +15 до 0 ",
    category: "rent",
    day: "пт-вс аренда",
    price: 15,
    shortly:
      "Новинка сезона 2021 - супер лёгкий спальный мешок-кокон BTrace Zero. Он идеально подойдёт для небольших путешествий в теплую погоду. Занимая совсем мало места, этот спальный мешок позволит с комфортом переночевать в походных условиях. Как и другие спальные мешки-коконы этой серии, BTrace Zero имеет возможность состёгиваться. Также можно выбрать один из 2х размеров, чтоб сэкономить ещё места и веса, если рост позволяет пользоваться спальным мешком меньшего размера.",
    column: [
      "Производитель: BTRACE",
      "Температура экстрима: 0",
      "Температура комфорта: +5",
      "Вес (г): 800",
      "Материал внешний: Полиэстер 20D 380Т Nylon RipStop WR",
      "Внутренний материал: 100% полиэстер 210T Soft Nylon",
      "Утеплитель: Izoshell Pro 2*80 г/м2",
      "Размер в упаковке (см): 52*25*25",
      "Размер (см): 220*90(55)",
      "Упаковка: Тканевый мешок",
    ],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК",
    img: "sleeping_bag_green.jpg",
    desc: "195*60см от +15 до 0",
    category: "rent",
    day: "будни/выходные",
    price: 8,
    column: ["Вес: 960гр", "Размер внешний: 35*26см"],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК",
    img: "sleeping_bag_red.jpg",
    desc: "Сampsor 210*66см от +10 до 0",
    category: "rent",
    day: "пн-чт аренда",
    price: 10,
    column: ["Вес: 1300гр", "Размер внешний: 33*24см"],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК",
    img: "sleeping_bag_red.jpg",
    desc: "Сampsor 210*66см от +10 до 0",
    category: "rent",
    day: "пт-вс аренда",
    price: 12,
    column: ["Вес: 1300гр", "Размер внешний: 33*24см"],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК",
    img: "sleppingbagNordway.jpg",
    desc: "NORDWAY TORONTO (OT +10) 215x75x75см",
    category: "rent",
    day: "пн-чт аренда",
    price: 8,
    column: [
      "Вес: 1070гр",
      "Молния	боковая",
      "Тип: мешок-одеяло",
      "Внешний материал	полиэстер",
      "Внутренний материал	полиэстер",
      "Утеплитель	синтетика",
    ],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК",
    img: "sleppingbagNordway.jpg",
    desc: "NORDWAY TORONTO (OT +10) 215x75x75см",
    category: "rent",
    day: "пт-вc аренда",
    price: 10,
    column: [
      "Вес: 1070гр",
      "Молния	боковая",
      "Тип: мешок-одеяло",
      "Внешний материал	полиэстер",
      "Внутренний материал	полиэстер",
      "Утеплитель	синтетика",
    ],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК",
    img: "sleeping3.jpg",
    desc: "Outventure Oregon +15 180*85см",
    category: "rent",
    day: "пн-чт аренда",
    price: 8,
    column: [
      "Вес: 850гр",
      "Размер в сложенном виде (дл х шир х выс):41*20*20",
      "Тип: мешок-одеяло",
      "Внешний материал	полиэстер",
      "Внутренний материал	полиэстер",
      "Утеплитель HollowFiber",
      "Верхняя температура комфорта +25",
      "Нижняя температура комфорта +15",
      "Экстремальная температура +5",
      "Вес утеплителя: 150 г/м2",
    ],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК",
    img: "sleeping3.jpg",
    desc: "Outventure Oregon +15 180*85см",
    category: "rent",
    day: "пт-вс аренда",
    price: 10,
    column: [
      "Вес: 850гр",
      "Размер в сложенном виде (дл х шир х выс):41*20*20",
      "Тип: мешок-одеяло",
      "Внешний материал	полиэстер",
      "Внутренний материал	полиэстер",
      "Утеплитель HollowFiber",
      "Верхняя температура комфорта +25",
      "Нижняя температура комфорта +15",
      "Экстремальная температура +5",
      "Вес утеплителя: 150 г/м2",
    ],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК",
    img: "sleeping-bag.jpg",
    desc: " HANNAH BIVAK  (от -5 до +9) 205*85см",
    category: "rent",
    day: "пн-чт аренда",
    price: 12,
    column: [
      "Вес:	1,7 кг",
      "Температура комфорта (град):	13 °С",
      "Наполнитель:	синтетика",
      "Экстремальная температура (град):	-18 °С",
      "Длина:	205 см",
      "Ширина в плечах:	80 см",
      "Ширина в ногах:	50 см",
      "Мин, температура комфорта (град):	3 °С",
      "Тип спальника:	кокон",
      "Компрессионный мешок:	есть",
      "Внешняя ткань:	полиэстр",
      "Подкладка:	полиэстр",
      "Двойная молния:	да",
    ],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК",
    img: "sleeping-bag.jpg",
    desc: " HANNAH BIVAK  (от -5 до +9) 205*85см",
    category: "rent",
    day: "пт-вт аренда",
    price: 15,
    column: [
      "Вес:	1,7 кг",
      "Температура комфорта (град):	13 °С",
      "Наполнитель:	синтетика",
      "Экстремальная температура (град):	-18 °С",
      "Длина:	205 см",
      "Ширина в плечах:	80 см",
      "Ширина в ногах:	50 см",
      "Мин, температура комфорта (град):	3 °С",
      "Тип спальника:	кокон",
      "Компрессионный мешок:	есть",
      "Внешняя ткань:	полиэстр",
      "Подкладка:	полиэстр",
      "Двойная молния:	да",
    ],
  },
  {
    id: uuid(),
    title: "СПАЛЬНЫЙ МЕШОК",
    img: "sleepongbagTwo.jpg",
    desc: "TENNIER INDUSTRIES 2B1 (от -20 до +20)",
    category: "rent",
    day: "будни/выходные",
    price: 15,
    column: [],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ",
    img: "backbag4.jpg",
    desc: "65L NORDWAY ",
    category: "rent",
    day: "будни/выходные",
    price: 10,
    shortly:
      "Этот рюкзак предназначен для пользователей, которые отправляются в поход по гористой местности или хотят отправиться на другой конец света и отправиться в свое первое приключение. Этот простой рюкзак, который очень удобен благодаря своим отделениям",
    column: [
      "Объем: 65 л",
      "Вес:	1,9 кг",
      "Число лямок: 2",
      "Подвесная система: анатомическая",
      "Боковая стяжка: есть",
      "Верхний клапан: есть",
      "Карманы: боковые карманы",
    ],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ",
    img: "THENORTHFACE_blue.jpg",
    desc: "50L THE NORTH FACE(REPLICA) ",
    category: "rent",
    day: "пн-чт аренда",
    price: 12,
    shortly:
      "Легкий, надежный и полностью регулируемый рюкзак для многодневных выходов и путешествий налегке. Рюкзак NorthFace обладая объемом 50л, подойдет для скалолазания, походов и путешествий.",
    column: ["Объем: 50л", "Конструкция: Мягкий (без элементов жесткости)"],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ",
    img: "THENORTHFACE_blue.jpg",
    desc: "50L THE NORTH FACE(REPLICA) ",
    category: "rent",
    day: "пт-вс аренда",
    price: 14,
    shortly:
      "Легкий, надежный и полностью регулируемый рюкзак для многодневных выходов и путешествий налегке. Рюкзак NorthFace обладая объемом 50л, подойдет для скалолазания, походов и путешествий.",
    column: ["Объем: 50л", "Конструкция: Мягкий (без элементов жесткости)"],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ",
    img: "backbag5.jpg",
    desc: "REGATTA 35L",
    category: "rent",
    day: "пн-чт аренда",
    price: 14,
    shortly:
      "Универсальный и прочный, он отлично подходит для походов и отпуска",
    column: [
      "Объем: 35л",
      "Материал: 100% полиэстер",
      "Размеры: 55x27,5x17,5 см",
      "2 сетчатых открытых боковых кармана",
      "Изготовлен из прочного материала с регулируемым поясным ремнем и нагрудными ремнями",
      "Боковые карманы на молнии обеспечивают дополнительное место для хранения",
      "Рюкзак имеет встроенные ранты для крепления треккинговых палок, сетчатые боковые карманы для бутылки с водой",
      "Дождевик, держатель для ключей, выдвижные застежки-молнии",
      "2 боковых кармана на молнии",
    ],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ",
    img: "backbag5.jpg",
    desc: "REGATTA 35L",
    category: "rent",
    day: "пт-вс аренда",
    price: 16,
    shortly:
      "Универсальный и прочный, он отлично подходит для походов и отпуска",
    column: [
      "Объем: 35л",
      "Материал: 100% полиэстер",
      "Размеры: 55x27,5x17,5 см",
      "2 сетчатых открытых боковых кармана",
      "Изготовлен из прочного материала с регулируемым поясным ремнем и нагрудными ремнями",
      "Боковые карманы на молнии обеспечивают дополнительное место для хранения",
      "Рюкзак имеет встроенные ранты для крепления треккинговых палок, сетчатые боковые карманы для бутылки с водой",
      "Дождевик, держатель для ключей, выдвижные застежки-молнии",
      "2 боковых кармана на молнии",
    ],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ",
    img: "backbag9.jpg",
    desc: "OUTVENTURE 65L",
    category: "rent",
    day: "пн-чт аренда",
    price: 16,
    shortly:
      "Универсальный и прочный, он отлично подходит для походов и отпуска",
    column: [
      "Объем: 65л",
      "Материал: 100% полиэстер",
      "Размеры: 20 x 32 x 85 см",
      "Вес: 1.8кг",
      "Боковые стяжки: Да",
      "Вентиляция спины: Да",
      "Верхний клапан: Да",
      "Количество боковых карманов: 2",
      "Количество отделений: 1",
      "Крепление для ледового инструмента: Да",
      "Крепление для палок: Да",
      "Нагрудный ремень: Да",
      "Поясной ремень: Да",
      "Регулировка клапанов: Да",
      "Фронтальный карман: Да",
      "Число лямок: 2",
    ],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ",
    img: "backbag9.jpg",
    desc: "OUTVENTURE 65L",
    category: "rent",
    day: "пт-вс аренда",
    price: 18,
    shortly:
      "Универсальный и прочный, он отлично подходит для походов и отпуска",
    column: [
      "Объем: 65л",
      "Материал: 100% полиэстер",
      "Размеры: 20 x 32 x 85 см",
      "Вес: 1.8кг",
      "Боковые стяжки: Да",
      "Вентиляция спины: Да",
      "Верхний клапан: Да",
      "Количество боковых карманов: 2",
      "Количество отделений: 1",
      "Крепление для ледового инструмента: Да",
      "Крепление для палок: Да",
      "Нагрудный ремень: Да",
      "Поясной ремень: Да",
      "Регулировка клапанов: Да",
      "Фронтальный карман: Да",
      "Число лямок: 2",
    ],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ",
    img: "backbag11.jpg",
    desc: "DEUTER PATAGONIA 70+15L",
    category: "rent",
    day: "пн-чт аренда",
    price: 18,
    shortly:
      "Универсальный и прочный, он отлично подходит для походов и отпуска",
    column: [
      "Объем: 70+15л",
      "Вес:  2.7кг",
      "Объём рюкзака регулируется вертикальными и горизонтальными стропами",
      "Имеется большой внешний карман для разных походных принадлежностей или мокрой одежды",
      "Возможность крепления дополнительного походного снаряжения",
      "Регулировка объема",
      "Фурнитура: Duraflex",
      "Вентиляция спины",
      "Грудной фиксатор",
      "нутренняя перегородка",
      "Наружные карманы",
      "Клапан: Съемный клапан с карманами",
    ],
  },
  {
    id: uuid(),
    title: "РЮКЗАК ТУРИСТИЧЕСКИЙ",
    img: "backbag11.jpg",
    desc: "DEUTER PATAGONIA 70+15L",
    category: "rent",
    day: "пт-вс аренда",
    price: 20,
    shortly:
      "Универсальный и прочный, он отлично подходит для походов и отпуска",
    column: [
      "Объем: 70+15л",
      "Вес:  2.7кг",
      "Объём рюкзака регулируется вертикальными и горизонтальными стропами",
      "Имеется большой внешний карман для разных походных принадлежностей или мокрой одежды",
      "Возможность крепления дополнительного походного снаряжения",
      "Регулировка объема",
      "Фурнитура: Duraflex",
      "Вентиляция спины",
      "Грудной фиксатор",
      "нутренняя перегородка",
      "Наружные карманы",
      "Клапан: Съемный клапан с карманами",
    ],
  },
  {
    id: uuid(),
    title: "СТОЛ СКЛАДНОЙ",
    img: "table2.jpg",
    desc: "72*60*49 см",
    category: "rent",
    day: "будни/выходные",
    price: 10,
    column: [],
  },
  {
    id: uuid(),
    title: "МАНГАЛ СКЛАДНОЙ",
    img: "mangal.jpg",
    desc: "СКЛАДНОЙ",
    category: "rent",
    day: "будни/выходные",
    price: 15,
    column: [],
  },
  {
    id: uuid(),
    title: "НАБОР ШАМПУРОВ",
    img: "fit.jpg",
    desc: "6 шт",
    category: "rent",
    day: "будни/выходные",
    price: 5,
    column: [],
  },
  {
    id: uuid(),
    title: "ГРИЛЬ - РЕШЕТКА ",
    img: "grillGrate.jpg",
    desc: "40*33 см",
    category: "rent",
    day: "будни/выходные",
    price: 5,
    column: [],
  },
  {
    id: uuid(),
    title: "ТЕРМОРЮКЗАК С ПОСУДОЙ",
    img: "termobackbag.jpg",
    desc: "НА 4 ЧЕЛОВЕК",
    category: "rent",
    day: "пн-чт аренда",
    price: 12,
    column: [],
  },
  {
    id: uuid(),
    title: "ТЕРМОРЮКЗАК С ПОСУДОЙ",
    img: "termobackbag.jpg",
    desc: "НА 4 ЧЕЛОВЕК",
    category: "rent",
    day: "пт-вс аренда",
    price: 15,
    column: [],
  },
  {
    id: uuid(),
    title: "МНОГОФУНКЦИОНАЛЬНЫЙ HOЖ 6 B 1 ",
    img: "knife.jpg",
    desc: "EXPEDITION",
    category: "rent",
    day: "будни/выходные",
    price: 2,
    column: [],
  },
  {
    id: uuid(),
    title: "ВЕТРОЗАЩИТНЫЙ ЭКРАН ДЛЯ ГОРЕЛКИ",
    img: "screen.jpg",
    desc: "HIGHROCK",
    category: "rent",
    day: "будни/выходные",
    price: 2,
    column: [],
  },
  {
    id: uuid(),
    title: "ТРЕКИНГОВЫЕ ПАЛКИ DECATHLON",
    img: "trekking_poles_DECATHLON.avif",
    desc: "Комплекст из 2шт, алюминиевые ",
    category: "rent",
    day: "пн-чт аренда",
    price: 4,
    shortly:
      "Простая, но эффективная система регулировки Push-pin. Он имеет простую систему на кнопочной системе.",
    column: [
      "3 телескопические части",
      "Размер яруса: 55 см",
      "Ширина в раскрытом виде: ~5см",
      "Алюминиевые стержни 6061-T6",
      "Диаметр стержня 20/18/16 мм",
      "Стальной наконечник",
      "Вес: 200 гр.",
    ],
  },
  {
    id: uuid(),
    title: "ТРЕКИНГОВЫЕ ПАЛКИ DECATHLON",
    img: "trekking_poles_DECATHLON.avif",
    desc: "Комплекст из 2шт, алюминиевые ",
    category: "rent",
    day: "пт-вс аренда",
    price: 5,
    shortly:
      "Простая, но эффективная система регулировки Push-pin. Он имеет простую систему на кнопочной системе.",
    column: [
      "3 телескопические части",
      "Размер яруса: 55 см",
      "Ширина в раскрытом виде: ~5см",
      "Алюминиевые стержни 6061-T6",
      "Диаметр стержня 20/18/16 мм",
      "Стальной наконечник",
      "Вес: 200 гр.",
    ],
  },
  {
    id: uuid(),
    title: "CИДЕНЬЕ ТУРИСТИЧЕСКОЕ DECATHLON",
    img: "sitting_DECATHLON.png",
    desc: "Из пеноматериала с металлизированным слоем",
    category: "rent",
    day: "будни/выходные",
    price: 2,
    shortly:
      "Сиденье с металлическим каркасом из пеноматериала, подходящий для треккинга.",
    column: [
      "Вес: 60 г",
      "Размеры: 34*23,7*1,5 см",
      "Эластичная лента с клипсой обеспечивает комфортное использование",
    ],
  },
  {
    id: uuid(),
    title: "ФОНАРЬ НАЛОБНЫЙ 30 LUMEN ONNIGHT 50",
    img: "lantern_black.jpg",
    desc: "Дальность  освещения: 15м (30 люмен). 1 режима освещения.",
    category: "rent",
    day: "с батарейкой",
    price: 4,
    column: [
      "Питание:2 шт ААА(в наборе)",
      "Автономность: 25 часов",
      "Вес: 65г",
      "Одна кнопка ON/OFF для удобства использования в перчатках или рукавицах",
      "Регулируемый ремешок",
      "Защита от брызг и ударов",
    ],
  },
  {
    id: uuid(),
    title: "ФОНАРЬ НАЛОБНЫЙ 30 LUMEN ONNIGHT 50",
    img: "lantern_black.jpg",
    desc: "Дальность  освещения: 15м (30 люмен). 1 режима освещения.",
    category: "rent",
    day: "без батарейки",
    price: 3,
    column: [
      "Питание:2 шт ААА(в наборе)",
      "Автономность: 25 часов",
      "Вес: 65г",
      "Одна кнопка ON/OFF для удобства использования в перчатках или рукавицах",
      "Регулируемый ремешок",
      "Защита от брызг и ударов",
    ],
  },
  {
    id: uuid(),
    title: "КОВРИК ДЛЯ ЙОГИ/ПЕНКА",
    img: "mat2.jpg",
    desc: "175/180*60*1 см ",
    category: "rent",
    day: "будни/выходные",
    price: 4,
    column: ["Материал: ЭВА"],
  },
  {
    id: uuid(),
    title: "КОВРИК С АЛЮМИНИЕВОЙ ФОЛЬГОЙ FORA",
    img: "mat_aluminum_foil_FORA.jpg",
    desc: "180*60/50*0,4 см ",
    category: "rent",
    day: "будни/выходные",
    price: 3,
    column: ["Однослойный"],
  },
  {
    id: uuid(),
    title: "ГОРЕЛКА ТУРИСТИЧЕСКАЯ",
    img: "burner32.jpg",
    desc: "Nurgaz TS-5310 ",
    category: "rent",
    day: "будни/выходные",
    price: 4,
    column: [
      "Мощная нержавеющая горелка",
      "Клапан мирового класс 7/16",
      "Долговечный латунный кран",
      "Производство: Турция",
    ],
  },
  {
    id: uuid(),
    title: "ГЕРМОПАКЕТ BTRACE",
    img: "packageBTRACE.jpg",
    desc: "ПЛОСКИЙ ПВХ 20*13*1.5см",
    category: "rent",
    day: "будни/выходные",
    price: 3,
    column: ["Материал: ПВХ"],
  },

  {
    id: uuid(),
    title: "ЧАЙНИК ПОХОДНЫЙ BTRACE 1,1Л",
    img: "teapot_BTRACE1.jpg",
    desc: "Алюминий анодированный",
    category: "rent",
    day: "пн-чт аренда",
    price: 4,
    column: ["Вес (г): 215", "Объем (мл): 1100"],
  },
  {
    id: uuid(),
    title: "ЧАЙНИК ПОХОДНЫЙ BTRACE 1,1Л",
    img: "teapot_BTRACE1.jpg",
    desc: "Алюминий анодированный",
    category: "rent",
    day: "пт-вс аренда",
    price: 6,
    column: ["Вес (г): 215", "Объем (мл): 1100"],
  },
  {
    id: uuid(),
    title: "НАБОР ПОСУДЫ",
    img: "set.jpg",
    desc: "КАСТРЮЛЯ, СОТЕЙНИК, СКОВОРОДА, ТКАНЕВАЯ ПРИХВАТКА",
    category: "rent",
    day: "будни/выходные",
    price: 12,
    column: [
      "Чайник: Диаметр низа: 14 см; Диаметр верха: 9 см; Высота: 8 см.",
      "Кастрюля: Диаметр: 16,5 см; Высота: 9 см; Длина ручки: 10 см.",
      "Сковорода: Диаметр: 17 см; Высота: 4,5 см; Длина ручки: 10 см.",
    ],
  },
  {
    id: uuid(),
    title: "ЗАЖИМ ДЛЯ КАСТРЮЛИ И СКОВОРОДКИ И ПРОЧИХ ПРЕДМЕТОВ",
    img: "clip.jpg",
    desc: "ЧАПЕЛЬНИК",
    category: "rent",
    day: "будни/выходные",
    price: 2,
    column: [
      "Легкий алюминиевый чапельник обезопасит приготовление пищи на газовой горелке или таганке",
      "Размер:  12,5*2,8*2,5 см",
      "Вес: 40 гр",
    ],
  },
  {
    id: uuid(),
    title: "ГОРЕЛКА",
    img: "primusLite.jpg",
    desc: "PRIMUS LITE PLUS",
    category: "rent",
    day: "будни/выходные",
    price: 15,
    column: [],
  },
  {
    id: uuid(),
    title: "ЗОНТ ПЛЯЖНЫЙ (СКЛАДНОЙ)",
    img: "umbrella.jpg",
    desc: "35*26см вес 0,510кг",
    category: "rent",
    day: "пн-чт аренда",
    price: 2,
    column: [
      "Материал купола: Нейлон",
      "Регулировка высоты: Есть",
      "Вес: 600гр",
    ],
  },
  {
    id: uuid(),
    title: "ЗОНТ ПЛЯЖНЫЙ (СКЛАДНОЙ)",
    img: "umbrella.jpg",
    desc: "35*26см вес 0,510кг",
    category: "rent",
    day: "пт-вс аренда",
    price: 3,
    column: [
      "Материал купола: Нейлон",
      "Регулировка высоты: Есть",
      "Вес: 600гр",
    ],
  },
  {
    id: uuid(),
    title: "ТЕНТ ПОЛИЭСТЕР 4*4м",
    img: "awning.jpg",
    desc: "35*26см вес 0,510кг",
    category: "rent",
    day: "пн-чт аренда",
    price: 5,
    column: ["Материал тента: Полиэстер с ПУ пропиткой"],
  },
  {
    id: uuid(),
    title: "ТЕНТ ПОЛИЭСТЕР 4*4м",
    img: "awning.jpg",
    desc: "35*26см вес 0,510кг",
    category: "rent",
    day: "пт-вс аренда",
    price: 7,
    column: ["Материал тента: Полиэстер с ПУ пропиткой"],
  },
];
